import Login from "../pages/Login";
import Tasks from "../pages/Tasks";

export const ROUTES = [
    {
        path:"/",
        element: <Login/>
    },
    {
        path:'/tasks',
        element: <Tasks/>

    }
]